import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  data: [],
  pronounceDataSpeech: null,
  pairDataSpeech: [],
  practiceDataSpeech: null,
  openReportErrorForm: false,
  isShowConfirmClose: false,
  isShowIntroduce: false,
  totalPronounceRecording: 0,
  totalPairRecording: {},
  totalPracticeRecording: 0,
  isGoodRecording: true,
  micAnchor: null,
  isRender: true,
}

export const gymSlice = createSlice({
  name: 'gym',
  initialState,
  reducers: {
    updateGymList: (state, action: any) => {
      state.data = action.payload
    },
    updatePronounceDataSpeech: (state, action) => {
      state.pronounceDataSpeech = action.payload
    },
    updatePairDataSpeech: (state, action) => {
      state.pairDataSpeech = action.payload
    },
    updatePracticeDataSpeech: (state, action) => {
      state.practiceDataSpeech = action.payload
    },
    updateOpenReportForm: (state, action) => {
      state.openReportErrorForm = action.payload
    },
    updateIsShowConfirmClose: (state, action) => {
      state.isShowConfirmClose = action.payload
    },
    upDateIsShowIntroduce: (state, action) => {
      state.isShowIntroduce = action.payload
    },
    upDateTotalPronounceRecording: (state, action) => {
      state.totalPronounceRecording = action.payload
    },
    upDateTotalPairRecording: (state, action) => {
      state.totalPairRecording = action.payload
    },
    upDateTotalPracticeRecording: (state, action) => {
      state.totalPracticeRecording = action.payload
    },
    upDateIsGoodRecording: (state, action) => {
      state.isGoodRecording = action.payload
    },
    updateMicAnchor: (state, action) => {
      state.micAnchor = action.payload
    },
    updateRerender: (state, action) => {
      state.isRender = action.payload
    },
    resetGymState: state => {
      state.data = []
      state.pronounceDataSpeech = null
      state.pairDataSpeech = []
      state.practiceDataSpeech = null
      state.openReportErrorForm = false
      state.isShowConfirmClose = false
      state.isShowIntroduce = false
      state.totalPronounceRecording = 0
      state.totalPairRecording = {}
      state.totalPracticeRecording = 0
      state.isGoodRecording = true
      state.micAnchor = null
    },
  },
})

export const {
  updateGymList,
  updateOpenReportForm,
  updateIsShowConfirmClose,
  updatePronounceDataSpeech,
  updatePairDataSpeech,
  updatePracticeDataSpeech,
  upDateIsShowIntroduce,
  upDateTotalPronounceRecording,
  upDateTotalPairRecording,
  upDateTotalPracticeRecording,
  upDateIsGoodRecording,
  updateMicAnchor,
  resetGymState,
  updateRerender,
} = gymSlice.actions

export default gymSlice.reducer
